export default "__VITE_ASSET__LpdCjJ_P__"